let domLoaded = false;
let igReady = false;

/**
 * Whether an assigned Intelligems group is the one with this ID.
 *
 * Matching on the ID rather than the group name is what makes a test survive someone renaming a group in Intelligems —
 * a rename, or a special dash character pasted into a name, otherwise stops the body class ever landing with no error
 * anywhere to show for it.
 *
 * Intelligems shows a group's ID in two forms: the full UUID, and a short "for integrations" form that is just its
 * last segment. Either can be the one that reaches the storefront object, so both are accepted. The length floor stops
 * a truncated or empty value matching everything.
 */
function cMatchesGroupId(group, fullId) {
  const id = group?.id;

  return typeof id === "string" && id.length >= 12 && fullId.endsWith(id);
}

function handleExperiments() {
  if (!domLoaded || !igReady) return;


  // V_CRT_PDP_03 | Buy 2 Get 2 as third tier - BFS
  //
  // Group IDs, not names — see cMatchesGroupId above.
  const V_CRT_PDP_03_VAR_A_ID = "7de25216-bfb4-45d1-a66c-f3bfcb547677";
  const V_CRT_PDP_03_VAR_B_ID = "ac0ec195-7148-427e-8321-1810907b7dec";

  const V_CRT_PDP_03 = window.igData?.user.getTestGroup("476455ca-4432-4209-b768-d665a63d858e");

  if (cMatchesGroupId(V_CRT_PDP_03, V_CRT_PDP_03_VAR_A_ID)) {
    document.body.classList.add("c-V_CRT_PDP_03-varA");
  } else if (cMatchesGroupId(V_CRT_PDP_03, V_CRT_PDP_03_VAR_B_ID)) {
    document.body.classList.add("c-V_CRT_PDP_03-varB");
  }

  // V_CRT_MIX_19 | Size Recommender v2: Step Count vs Toe Gap Copy vs Option Count
  //
  // Group IDs, not names — see cMatchesGroupId above.
  const V_CRT_MIX_19_VAR_A_ID = "4d4e96db-d9d5-4db0-8cff-cc6c02cfe1b5"; // "Var A - 5 steps same copy"
  const V_CRT_MIX_19_VAR_B_ID = "91463af5-6cf5-4833-90a1-b6d4cdc430e4"; // "Var B - 3 option new copy"
  const V_CRT_MIX_19_VAR_C_ID = "68f77f88-7377-48ba-a36c-93d015f98479"; // "Var C - 5 option new copy"

  const V_CRT_MIX_19 = window.igData?.user.getTestGroup("41d6c3db-fef2-4f2c-8299-4d80a9092f0f");

  if (cMatchesGroupId(V_CRT_MIX_19, V_CRT_MIX_19_VAR_A_ID)) {
    document.body.classList.add("c-V_CRT_MIX_19-varA");
  } else if (cMatchesGroupId(V_CRT_MIX_19, V_CRT_MIX_19_VAR_B_ID)) {
    document.body.classList.add("c-V_CRT_MIX_19-varB");
  } else if (cMatchesGroupId(V_CRT_MIX_19, V_CRT_MIX_19_VAR_C_ID)) {
    document.body.classList.add("c-V_CRT_MIX_19-varC");
  }

  // V_CRT_PDP_12 | Measure-First Size Experience on the PDP
  //
  // Group IDs, not names — see cMatchesGroupId above.
  const V_CRT_PDP_12_VAR_A_ID = "0efbf11e-f513-4758-861f-b2fe88a51ee4"; // "Var A - Combined table + CTA"
  const V_CRT_PDP_12_VAR_B_ID = "f0574679-88d3-4e0e-b91c-a8a7aebeeb2c"; // "Var B - Combined table, no CTA"
  const V_CRT_PDP_12_VAR_C_ID = "479f1491-41b7-4956-8e3e-043e06c02be6"; // "Var C - Combined table + How to measure"

  const V_CRT_PDP_12 = window.igData?.user.getTestGroup("68f0d54e-ac49-4213-8a8e-5bd5f3ab53c3");

  if (cMatchesGroupId(V_CRT_PDP_12, V_CRT_PDP_12_VAR_A_ID)) {
    document.body.classList.add("c-V_CRT_PDP_12-varA");
  } else if (cMatchesGroupId(V_CRT_PDP_12, V_CRT_PDP_12_VAR_B_ID)) {
    document.body.classList.add("c-V_CRT_PDP_12-varB");
  } else if (cMatchesGroupId(V_CRT_PDP_12, V_CRT_PDP_12_VAR_C_ID)) {
    document.body.classList.add("c-V_CRT_PDP_12-varC");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});
